import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DashboardFacade } from '../store/dashboard.facade';

@Component({
  selector: 'app-forgottendocumentwidget',
  templateUrl: './forgottendocumentwidget.component.html',
  styleUrls: ['./forgottendocumentwidget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ForgottendocumentwidgetComponent implements OnInit {

  public fetchForgottenDocuments$ = this.dashboardFacade$.forgottenDocuments$;
  constructor(private dashboardFacade$: DashboardFacade) { }

  ngOnInit(): void {
    this.dashboardFacade$.fetchForgottenDocuments()
  }
}